import { gql } from '@apollo/client';

export class UserGQLFunction {
  static GET_ALL_USERS = gql`
    query allUsers($page: Int!, $rowsPerPage: Int!) {
      allUsers(page: $page, rowsPerPage: $rowsPerPage) {
        len
        users {
          id
          userId
          username
          nickname
          title
          userType
          userState
          email
          deviceIds
          pushIds
        }
      }
    }
  `;

  static SEARCH_USERS = gql`
    query searchUsers($page: Int!, $rowsPerPage: Int!, $searchField: String!, $searchStr: String!) {
      searchUsers(page: $page, rowsPerPage: $rowsPerPage, searchField: $searchField, searchStr: $searchStr) {
        len
        users {
          id
          userId
          email
          password
          username
          nickname
          title
          userType
          userState
          deviceIds
          pushIds
        }
      }
    }
  `;

  static GET_USER_INFO = gql`
    query userInfo($id: String!) {
      userInfo(id: $id) {
        id
        userId
        email
        password
        username
        nickname
        title
        userType
        userState
        deviceIds
        pushIds
      }
    }
  `;

  static UPDATE_USER_STATE = gql`
    mutation updateUserState($id: String!, $userState: Int!) {
      updateUserState(id: $id, userState: $userState) {
        user {
          id
          userState
        }
        err
        msg
      }
    }
  `;

  static UPDATE_USER = gql`
    mutation updateUser(
      $id: String!
      $email: String!
      $username: String
      $nickname: String
      $title: String
      $userType: Int!
      $userState: Int!
    ) {
      updateUser(
        id: $id
        email: $email
        username: $username
        nickname: $nickname
        title: $title
        userType: $userType
        userState: $userState
      ) {
        user {
          id
          userId
          email
          password
          username
          nickname
          title
          userType
          userState
          deviceIds
          pushIds
        }
        err
        msg
      }
    }
  `;

  static DELETE_USER = gql`
    mutation removeUser($id: String!) {
      removeUser(id: $id) {
        user {
          id
          email
          username
          userType
          userState
        }
        err
        msg
      }
    }
  `;

  static GET_MSG_BACKUP_HISTORY = gql`
    query msgBackupHistory($userId: String!, $domain: String, $searchStr: String, $page: Int!, $rowsPerPage: Int!) {
      msgBackupHistory(userId: $userId, domain: $domain, searchStr: $searchStr, page: $page, rowsPerPage: $rowsPerPage) {
        len
        messages {
          id
          msgId
          userId
          from
          to
          msgType
          content
          timeSend
          timeBackup
          passkeyFingerprint
        }
      }
    }
  `;

  static GET_MSG_BACKUP_CONVERSATIONS = gql`
    query msgBackupConversations($userId: String!) {
      msgBackupConversations(userId: $userId)
    }
  `;

  static INIT_MESSAGE_HISTORY_SESSION = gql`
    mutation initMessageHistorySession($userId: String!) {
      initMessageHistorySession(userId: $userId) {
        err
        msg
      }
    }
  `;
}
